import { useShallowEqualSelector } from '../../utils';

const staffingSelector = state => state.staffing || {};

export const useStaffingSelector = () => {
  return useShallowEqualSelector(staffingSelector);
};
